
export const ROUTE_CONSTANTS  = {
  ROOT : "/",
  HOME : "/home",
  ADMIN : "/admin",
  ARTISAN : "/artisan",
  USER : "/user",
  CUSER : "/cuser",
  SEARCH : "/search",
  CONTACT_US : "/home/contactus",
  MEMBERSHIP_RENEWAL : "/home/membershiprenewal",
  END_USER_CONTACT_US : "/user/contactus",
  ARTISAN_USER_CONTACT_US : "/artisan/contactus",
  CORPORATE_USER_CONTACT_US : "/cuser/contactus",
  LOGIN : "/login",
  WELCOME : "/welcome",
  CREATE_NEW_USER : "/createuser",
  COMMON_RESET_PWD_SENT_MAIL_FORM_PATH : "information/resetPasswordSentMailForm",
  COMMON_RESET_PWD_SENT_MAIL_MSG_PATH : "../resetPasswordSentMailMsg",
  JD_SUCCESS_SUBMIT : "/application/apply/submit-success",
  TIU_SUCCESS_SUBMIT : "/application/apply/tiu-submit-success"
};



// WEBPACK FOOTER //
// ./src/app/common/constant/RouteConstants.ts